import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import AuthModal from '../components/AuthModal';

export default function AppLoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <AuthModal
        isOpen={open}
        defaultMode="login"
        infoMessage="앱에서 계속 이용하려면 로그인해 주세요."
        onClose={() => setOpen(false)}
        onSuccess={(data) => {
          auth.actions.loginSuccess(data, {
            source: 'app',
            preserveExistingIntent: true,
          });

          setOpen(false);

          const intent = auth.actions.consumeIntent();
          const nextPath = intent?.kind === 'app' && intent.path ? intent.path : '/app/analysis';
          navigate(nextPath, { replace: true });
          return false;
        }}
      />
    </div>
  );
}
